<template>
  <div id="PostalSetting">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            設定
          </div>
        </div>
        <div class="right" />
      </div>
      <el-tabs
        v-model="activeName"
        class="setUpTabs"
      >
        <!-- 郵件類型 -->
        <el-tab-pane
          label="郵件類型"
          name="mail"
        >
          <div class="inputWrap">
            <p>新增郵件類型</p>
            <el-input
              v-model="mailTypeInput"
              maxlength="10"
              placeholder="最多10個字元"
            />
            <el-button
              size="mini"
              plain
              @click="addItem('mailType')"
            >
              新增
            </el-button>
          </div>
          <p class="tableTitle">
            郵件類型列表
          </p>
          <el-table
            class="list"
            :data="mailTypeList"
            empty-text="目前無郵件類型"
            tooltip-effect="dark"
          >
            <el-table-column
              type="index"
              width="50"
            />
            <el-table-column
              label="郵件類型"
              prop="Name"
            />
            <el-table-column
              label="操作"
              width="180"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  plain
                  @click="delItem('mailType', scope.row.Id, scope.$index)"
                >
                  刪除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <TableLoading :is-loading="loading" />
        </el-tab-pane>
        <!-- /郵件類型 -->
        <!-- 物流 -->
        <el-tab-pane
          label="物流"
          name="logistic"
        >
          <div class="inputWrap">
            <p>新增物流</p>
            <el-input
              v-model="logisticInput"
              maxlength="10"
              placeholder="最多10個字元"
            />
            <el-button
              size="mini"
              plain
              @click="addItem('logistic')"
            >
              新增
            </el-button>
          </div>
          <p class="tableTitle">
            物流列表
          </p>
          <el-table
            class="list"
            :data="logisticList"
            empty-text="目前無物流"
            tooltip-effect="dark"
          >
            <el-table-column
              type="index"
              width="50"
            />
            <el-table-column
              label="物流名稱"
              prop="Name"
            />
            <el-table-column
              label="操作"
              width="180"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  plain
                  @click="delItem('logistic', scope.row.Id, scope.$index)"
                >
                  刪除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <TableLoading :is-loading="loading" />
        </el-tab-pane>
        <!-- /物流 -->
        <!-- 廠商 -->
        <el-tab-pane
          label="廠商"
          name="manufacturer"
        >
          <div class="inputWrap">
            <p>新增廠商</p>
            <el-input
              v-model="manufacturerInput"
              maxlength="10"
              placeholder="最多10個字元"
            />
            <el-button
              size="mini"
              plain
              @click="addItem('manufacturer')"
            >
              新增
            </el-button>
          </div>
          <p class="tableTitle">
            廠商列表
          </p>
          <el-table
            class="list"
            :data="manufacturerList"
            empty-text="目前無廠商"
            tooltip-effect="dark"
          >
            <el-table-column
              type="index"
              width="50"
            />
            <el-table-column
              label="廠商名稱"
              prop="Name"
            />
            <el-table-column
              label="操作"
              width="180"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  plain
                  @click="delItem('manufacturer', scope.row.Id, scope.$index)"
                >
                  刪除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <TableLoading :is-loading="loading" />
        </el-tab-pane>
        <!-- /物廠商 -->
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { apiPostal } from '@/api/Postal'
import TableLoading from '@/components/TableLoading'
export default {
  components: {
    TableLoading
  },
  data () {
    return {
      loading: true,
      activeName: 'mail',
      mailTypeInput: '',
      mailTypeList: [],
      logisticInput: '',
      logisticList: [],
      manufacturerInput: '',
      manufacturerList: [],
      isSending: false
    }
  },
  mounted () {
    this.getTypes()
  },
  methods: {
    getTypes () {
      return new Promise((resolve, reject) => {
        apiPostal.GetTypes()
          .then(res => {
            console.log(res)
            this.mailTypeList = res.data.Data.Lists[0].List
            this.logisticList = res.data.Data.Lists[1].List
            this.manufacturerList = res.data.Data.Lists[2].List
            this.loading = false
            resolve()
          })
          .catch(err => {
            console.log(err)
            reject(new Error('取得郵務設定失敗'))
          })
      })
    },
    filterType (type) {
      switch (type) {
        case 'mailType':
          return 'PostalType'
        case 'logistic':
          return 'PostalLogistics'
        case 'manufacturer':
          return 'PostalCompany'
      }
    },
    async addItem (type) {
      if (this.isSending) return
      if (this[`${type}Input`] === '') {
        this.$message({
          message: '請輸入類型名稱',
          type: 'warning'
        })
      } else if (this[`${type}Input`].indexOf(' ') !== -1 || this[`${type}Input`].indexOf('　') !== -1) {
        this.$message({
          message: '名稱不得有空白',
          type: 'warning'
        })
      } else if (this[`${type}List`].find(item => item.Name === this[`${type}Input`])) {
        this.$message({
          message: '此類型已存在',
          type: 'warning'
        })
      } else {
        this.isSending = true
        try {
          const params = {
            Type: this.filterType(type),
            TypeName: this[`${type}Input`]
          }
          await apiPostal.PostType(params)
          this.getTypes()
          this[`${type}Input`] = ''
        } catch (e) {
          console.log(e)
        } finally {
          this.isSending = false
        }
      }
    },
    delItem (type, id, index) {
      if (this.isSending) return
      this.$confirm('類型刪除後將無法復原，確定刪除？', '提示', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          this.isSending = true
          return new Promise((resolve, reject) => {
            const params = {
              Type: this.filterType(type),
              TypeId: id
            }
            apiPostal.DeleteType(params)
              .then(res => {
                console.log(res)
                this[`${type}List`].splice(index, 1)
                this.isSending = false
                resolve()
              })
              .catch(err => {
                console.log(err)
                this.isSending = false
                reject(new Error('刪除失敗'))
              })
          })
        })
        .catch(() => {
          console.log('cancel')
        })
    }
  }
}
</script>

<style lang="sass" scoped>
#PostalSetting
  text-align: center
  padding: 50px 0 10px
  height: 100%
  .main
    min-width: 1140px
    max-width: 90%
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      margin: 0 0 20px 0
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        margin-bottom: 10px
        text-align: left
    ::v-deep .el-tabs
      &.setUpTabs
      +basicTabs
      .el-tabs__header
        margin: 0 0 0
      .el-tabs__active-bar
        height: 4px
      .el-tabs__nav-wrap::after
        height: 4px
      .el-tabs__item
        height: 46px
        min-width: 120px
        &:nth-child(3)
          min-width: 100px
      .el-tab-pane
        padding-top: 25px
        .inputWrap
          padding-left: 8px
          text-align: left
          .el-input
            margin-top: 8px
            margin-right: 20px
            width: 305px
        .tableTitle
          flex: 1
          color: $mainFontColor
          text-align: left
          margin-top: 37px
          margin-bottom: 18px
          font-weight: bold
    ::v-deep .el-table
      &.list
      +basicTable
      .el-table__row
        td
          height: 58px
</style>
